(() => {
  const SELECTORS = {
    card: ".cstm-variant-button",
    dropdownWrap: ".main-cstm-dropdown",
    selectBtn: ".select-variant",
    swatchOptions: ".variant-swatch-options",
    swatch: ".variant-swatch",
    variantInput: "input[ref='variantId']",
    atcBtn: ".add-to-cart-button",
    cartDrawerTrigger: "cart-drawer-component button"
  };

  // Helper: open cart drawer
  function openCartDrawer() {
    const trigger = document.querySelector(SELECTORS.cartDrawerTrigger);
    if (trigger) trigger.click();
  }

  // Helper: wait for a cart update event, else timeout
  function waitForCartUpdate(timeout = 3000) {
    return new Promise(resolve => {
      let done = false;
      const finish = () => { if (!done) { done = true; resolve(); } };

      const handlers = [
        ["cart:updated", finish],
        ["cart:change", finish],
        ["ajaxProduct:added", finish],
        ["product:added", finish],
      ];

      handlers.forEach(([evt, fn]) => document.addEventListener(evt, fn, { once: true }));
      setTimeout(finish, timeout);
    });
  }

  // Document-level click delegation
  document.addEventListener("click", async (e) => {
    // 1) Toggle swatch panel via "Select Pack" button
    const selectBtn = e.target.closest(SELECTORS.selectBtn);
    if (selectBtn) {
      e.preventDefault();
      const picker = selectBtn.closest(SELECTORS.dropdownWrap);
      if (picker) {
        const panel = picker.querySelector(SELECTORS.swatchOptions);
        if (panel) {
          const wasActive = panel.classList.contains("active");
          
          // REQUIREMENT 3: Close all other open panels first
          document.querySelectorAll(`${SELECTORS.swatchOptions}.active`).forEach(el => el.classList.remove("active"));
          
          // Toggle the clicked one
          if (!wasActive) {
            panel.classList.add("active");
          }
        }
      }
      return; // stop here; no outside-close for this click
    }

    // 2) Swatch clicked
    const swatch = e.target.closest(SELECTORS.swatch);
    if (swatch) {
      e.preventDefault();

      const card = swatch.closest(SELECTORS.card);
      if (!card) return;

      const variantId = swatch.getAttribute("data-variant-id");
      if (!variantId) return;

      // Loader on the Select Pack button (scoped to this card)
      const btn = card.querySelector(SELECTORS.selectBtn);
      let originalHTML;
      if (btn) {
        originalHTML = btn.innerHTML;
        btn.classList.add("loading");
        btn.innerHTML = `<div class="loader"></div>`;
      }

      // Mark active swatch within this card only
      card.querySelectorAll(SELECTORS.swatch).forEach(s => s.classList.remove("active"));
      swatch.classList.add("active");

      // Update hidden variant input in this card
      const variantInput = card.querySelector(SELECTORS.variantInput);
      if (variantInput) variantInput.value = variantId;

      // Trigger this card’s ATC
      const atc = card.querySelector(SELECTORS.atcBtn);
      if (atc) {
        atc.click();
        // Wait for cart update (or fallback), then open drawer
        await waitForCartUpdate(1500);
        openCartDrawer();
        document.dispatchEvent(new CustomEvent("cart:updated:forced")); // optional signal
      }

      // Restore button
      if (btn) {
        btn.classList.remove("loading");
        btn.innerHTML = originalHTML;
      }

      // Close this card’s swatch panel
      const panel = card.querySelector(SELECTORS.swatchOptions);
      if (panel) panel.classList.remove("active");

      // Close other active panels just in case
      document.querySelectorAll(`${SELECTORS.swatchOptions}.active`).forEach(el => el.classList.remove("active"));

      return;
    }

    // 3) Clicked outside any open swatch panel → close all except the clicked area
    // REQUIREMENTS 1 & 2: Checks if the click target is outside the dropdown wrapping container
    const clickedPicker = e.target.closest(SELECTORS.dropdownWrap);
    document.querySelectorAll(`${SELECTORS.swatchOptions}.active`).forEach(panel => {
      if (!clickedPicker || !clickedPicker.contains(panel)) {
        panel.classList.remove("active");
      }
    });
  });
})();

$(document).ready(function(){
  $(".video_icon_home .icon-block img").on("click", function() {
    // Hide the clicked image
    console.log("image_icons");
    $(this).hide();

    // Find the next video tag and play it
    let video = $(this).next("video").get(0);
    if (video) {
      video.play();
    }
  });
});
// (() => {
//   const SELECTORS = {
//     card: ".cstm-variant-button",
//     dropdownWrap: ".main-cstm-dropdown",
//     selectBtn: ".select-variant",
//     swatchOptions: ".variant-swatch-options",
//     swatch: ".variant-swatch",
//     variantInput: "input[ref='variantId']",
//     atcBtn: ".add-to-cart-button",
//     cartDrawerTrigger: "cart-drawer-component button"
//   };

//   // Helper: open cart drawer
//   function openCartDrawer() {
//     const trigger = document.querySelector(SELECTORS.cartDrawerTrigger);
//     if (trigger) trigger.click();
//   }

//   // Helper: wait for a cart update event, else timeout
//   function waitForCartUpdate(timeout = 3000) {
//     return new Promise(resolve => {
//       let done = false;
//       const finish = () => { if (!done) { done = true; resolve(); } };

//       const handlers = [
//         ["cart:updated", finish],
//         ["cart:change", finish],
//         ["ajaxProduct:added", finish],
//         ["product:added", finish],
//       ];

//       handlers.forEach(([evt, fn]) => document.addEventListener(evt, fn, { once: true }));
//       setTimeout(finish, timeout);
//     });
//   }

//   // Document-level click delegation
//   document.addEventListener("click", async (e) => {
//     // 1) Toggle swatch panel via "Select Pack" button
//     const selectBtn = e.target.closest(SELECTORS.selectBtn);
//     if (selectBtn) {
//       e.preventDefault();
//       const picker = selectBtn.closest(SELECTORS.dropdownWrap);
//       if (picker) {
//         const panel = picker.querySelector(SELECTORS.swatchOptions);
//         if (panel) panel.classList.toggle("active");
//       }
//       return; // stop here; no outside-close for this click
//     }

//     // 2) Swatch clicked
//     const swatch = e.target.closest(SELECTORS.swatch);
//     if (swatch) {
//       e.preventDefault();

//       const card = swatch.closest(SELECTORS.card);
//       if (!card) return;

//       const variantId = swatch.getAttribute("data-variant-id");
//       if (!variantId) return;

//       // Loader on the Select Pack button (scoped to this card)
//       const btn = card.querySelector(SELECTORS.selectBtn);
//       let originalHTML;
//       if (btn) {
//         originalHTML = btn.innerHTML;
//         btn.classList.add("loading");
//         btn.innerHTML = `<div class="loader"></div>`;
//       }

//       // Mark active swatch within this card only
//       card.querySelectorAll(SELECTORS.swatch).forEach(s => s.classList.remove("active"));
//       swatch.classList.add("active");

//       // Update hidden variant input in this card
//       const variantInput = card.querySelector(SELECTORS.variantInput);
//       if (variantInput) variantInput.value = variantId;

//       // Trigger this card’s ATC
//       const atc = card.querySelector(SELECTORS.atcBtn);
//       if (atc) {
//         atc.click();
//         // Wait for cart update (or fallback), then open drawer
//         await waitForCartUpdate(1500);
//         openCartDrawer();
//         document.dispatchEvent(new CustomEvent("cart:updated:forced")); // optional signal
//       }

//       // Restore button
//       if (btn) {
//         btn.classList.remove("loading");
//         btn.innerHTML = originalHTML;
//       }

//       // Close this card’s swatch panel
//       const panel = card.querySelector(SELECTORS.swatchOptions);
//       if (panel) panel.classList.remove("active");

//       return;
//     }

//     // 3) Clicked outside any open swatch panel → close all
//     if (!e.target.closest(SELECTORS.dropdownWrap) && !e.target.closest(SELECTORS.selectBtn)) {
//       document.querySelectorAll(`${SELECTORS.swatchOptions}.active`).forEach(el => el.classList.remove("active"));
//     }
//   });
// })();
// $(document).ready(function(){
//   $(".video_icon_home .icon-block img").on("click", function() {
//   // Hide the clicked image
//   console.log("image_icons");
//   $(this).hide();

//   // Find the next video tag and play it
//   let video = $(this).next("video").get(0);
//   if (video) {
//     video.play();
//   }
// });
// });
